import { IBasePickerSuggestionsProps } from '@fluentui/react';

interface SuggestionPropsComponentProps {
    isDarkmode: boolean;
}

export const createSuggestionProps = ({ isDarkmode }: SuggestionPropsComponentProps): IBasePickerSuggestionsProps => ({
    suggestionsHeaderText: 'Suggested Items',
    noResultsFoundText: 'No results found',
    loadingText: 'Loading',
    showRemoveButtons: false,
    suggestionsAvailableAlertText: 'Picker Suggestions available',
    suggestionsContainerAriaLabel: 'Suggested items',
    resultsMaximumNumber: 50,
    searchForMoreText: 'Get all results',
    searchingText: 'Fetching all results...',
    resultsFooterFull: () => (
        <div style={{ textAlign: 'center', color: isDarkmode ? 'rgb(208, 208, 208)' : 'rgb(96, 94, 92)', fontSize: '12px', lineHeight: '30px' }}>
            Max results reached, please specify search
        </div>
    ),
    resultsFooter: () => (
        <div style={{ textAlign: 'center', color: isDarkmode ? 'rgb(208, 208, 208)' : 'rgb(96, 94, 92)', fontSize: '12px', lineHeight: '30px' }}>
            All results shown
        </div>
    ),
});
